import MillManagementFormContainer from './MillManagementFormContainer'

function MillManagementFormScreen(): JSX.Element {
    return <MillManagementFormContainer />
}

export default MillManagementFormScreen
